import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69e592e38485e20014541b4e_1784547055293_1672e4a6/seriousleverage/src/app/sign-up-login-screen/components/AuthScreen.tsx");
